import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import apiClient from '../../api/apiClient';

const DigiLockerCallback = () => {
    const location = useLocation();
    const [status, setStatus] = useState('Verifying...');
    const [error, setError] = useState(null);

    useEffect(() => {
        const verifyDigiLocker = async () => {
            const queryParams = new URLSearchParams(location.search);
            const code = queryParams.get('code');
            const state = queryParams.get('state');

            if (!code) {
                setError('Authorization code not found.');
                setStatus('Failed');
                return;
            }

            try {
                // We use apiClient to include authToken automatically
                const response = await apiClient.post('/vendors/digilocker/verify', {
                    code,
                    state
                });

                if (response.data.success) {
                    setStatus('Verification Successful! Closing window...');
                    if (window.opener) {
                        window.opener.postMessage({
                            type: 'DIGILOCKER_SUCCESS',
                            data: response.data.data
                        }, '*');
                    }
                } else {
                    throw new Error(response.data.message || 'Verification failed');
                }
            } catch (err) {
                console.error('DigiLocker verification error:', err);
                setError(err.response?.data?.message || err.message || 'Verification failed');
                setStatus('Failed');
                if (window.opener) {
                    window.opener.postMessage({
                        type: 'DIGILOCKER_ERROR',
                        error: err.response?.data?.message || err.message
                    }, '*');
                }
            } finally {
                // Give it a short delay to show the message before closing
                setTimeout(() => {
                    window.close();
                }, 3000);
            }
        };

        verifyDigiLocker();
    }, [location]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
            <h2>DigiLocker Authentication</h2>
            {status === 'Verifying...' && <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>}
            <p className={`mt-3 ${error ? 'text-danger' : 'text-success'}`}>{error || status}</p>
        </div>
    );
};

export default DigiLockerCallback;
